import React, { useState } from "react";
import { Client } from "@twilio/conversations";

import NewMessageModal from "../modals/NewMessageModal";
import { startSmsConversation } from "../../api";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators, AppState } from "../../store";

const lastTenDigits = (value: string | null) =>
  (value ?? "").replace(/\D/g, "").slice(-10);

interface NewConvoProps {
  client?: Client;
}

const CreateConversationButton: React.FC<NewConvoProps> = (
  props: NewConvoProps
) => {
  const dispatch = useDispatch();
  const { updateCurrentConversation, updateParticipants } = bindActionCreators(
    actionCreators,
    dispatch
  );
  const conversations = useSelector((state: AppState) => state.convos);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = () => setIsModalOpen(true);

  return (
    <>
      <button
        type="button"
        className="ios-icon-button"
        onClick={handleOpen}
        title="New message"
        aria-label="New message"
      >
        {/* Square-and-pencil compose icon */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M19 13.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5.5"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
          />
          <path
            d="M18.4 3.6a1.9 1.9 0 0 1 2.7 2.7L12.5 15 9 16l1-3.5z"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <NewMessageModal
        isModalOpen={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        onSave={async (recipient: string) => {
          // Open the existing thread with this number instead of a duplicate
          const existing = conversations.find(
            (convo) =>
              lastTenDigits(convo.friendlyName) === lastTenDigits(recipient)
          );
          const sid =
            existing?.sid ??
            (
              await startSmsConversation(
                recipient,
                updateParticipants,
                props.client
              )
            ).sid;
          setIsModalOpen(false);
          updateCurrentConversation(sid);
        }}
      />
    </>
  );
};

export default CreateConversationButton;
